import Vue from 'vue'
import { visitTypeServices } from '@/components/appointment/formFieldsCreate/appointmentFormDefaults'

export const isServiceAVisitType = (appointment) => visitTypeServices.includes(appointment.type)
export const hasGroupId = (groupId) => groupId !== undefined && groupId !== null && groupId !== ''
  const getRoles = () => (localStorage.getItem('access_roles') || '').split(',').filter(Boolean)

export const isAdminOrPartnerFromStorage = () => {
  const roles = getRoles()
  return roles.includes('ROLE_ADMIN') || roles.includes('ROLE_PARTNER')
}

export const isRealEstateFromStorage = () => {
  const roles = getRoles()
  return roles.includes('ROLE_REAL_ESTATE') || roles.includes('ROLE_REAL_ESTATE_OPERATOR')
}

export const SAAS_SUBSCRIPTION_TYPES = ['PREPAID_SAAS', 'POSTPAID_SAAS']

export const isSaasRealEstateFromStorage = () =>
  SAAS_SUBSCRIPTION_TYPES.includes(localStorage.getItem('users_real_estate_subscription_type'))

export const isAustralianFromStorage = () => localStorage.getItem('user_country') === 'AU'

// Reabertura de vistoria finalizada: autoatendimento de cliente SaaS e da operação australiana
export const canReopenAppointment = (appointment) =>
  !!appointment?.host && (isSaasRealEstateFromStorage() || isAustralianFromStorage())

export const canRemoveGroup = (groupId) => hasGroupId(groupId)
export const canAddHost = (appointment, groupId, isAdminOrPartner) => ['OPEN', 'DRAFT', 'REJECTED'].includes(appointment.status) && !appointment.host && !hasGroupId(groupId) && isAdminOrPartner
export const canCancel = (appointment, groupId) => appointment.status !== 'CANCELED' && appointment.status !== 'DONE' && !hasGroupId(groupId)
export const canEditVisitor = (appointment) => appointment.status !== 'CANCELED' && appointment.status !== 'DONE'
export const canChangeAppointmentType = (appointment, isAdminOrPartner) => appointment.status === 'OPEN' && isAdminOrPartner
export const canChangeAppointmentStatus = (appointment, isAdminOrPartner, isRealEstate, groupId) => {
  if (hasGroupId(groupId)) return false
  if (appointment.status === 'CANCELED') return false
  if (isAdminOrPartner) return true
  if (!isRealEstate) return false

  if (appointment.status === 'DONE') return canReopenAppointment(appointment)

  return ['DRAFT', 'OPEN'].includes(appointment.status)
}

export const canChangeAppointmentKeyLocation = (appointment, isAdminOrPartner) => appointment.status === 'OPEN' && !appointment.host && isAdminOrPartner
export const canSendConfirmationEmail = (appointment, isAdminOrPartner) =>  ['DRAFT', 'REJECTED', 'OPEN', 'SCHEDULED'].includes(appointment.status) && isAdminOrPartner
export const canAddOrEditObservations = (isAdminOrPartner) => isAdminOrPartner
// Alteração do adicional sem reagendar: mesmos perfis que já editam o valor pelo reagendamento
export const canUpdateDisplacement = (appointment, groupId, isAdminOrPartner, isRealEstate) =>
  ['DRAFT', 'OPEN', 'REJECTED', 'SCHEDULED'].includes(appointment.status)
  && !appointment.started
  && !hasGroupId(groupId)
  && (isAdminOrPartner || isRealEstate)
// Confirmação manual e página de confirmação: além da Hauseful, liberadas para a imobiliária da
// operação australiana, que já faz esse atendimento; no Brasil seguem escondidas por ora.
export const canConfirmAppointmentManually = (isAdminOrPartner) =>
  isAdminOrPartner || (isRealEstateFromStorage() && isAustralianFromStorage())
export const canAddOrEditCustomFields = (isAdminOrPartner) => isAdminOrPartner
export const canViewConfirmAppointmentPage = (isAdminOrPartner) =>
  isAdminOrPartner || (isRealEstateFromStorage() && isAustralianFromStorage())
export const canChangeHost = (appointment, groupId, isAdminOrPartner) => ['SCHEDULED', 'REJECTED'].includes(appointment.status) && !hasGroupId(groupId) && isAdminOrPartner && appointment.host
// Equipe interna: a imobiliária define ou troca o próprio vistoriador; host do marketplace segue com a Hauseful
export const canChangeInspector = (appointment, groupId, isRealEstate) =>
  isRealEstate
  && appointment.worker_type === 'INTERNAL'
  && ['DRAFT', 'OPEN', 'REJECTED', 'SCHEDULED'].includes(appointment.status)
  && !appointment.started
  && !hasGroupId(groupId ?? appointment.group_id)
export const canSendPropertyManagerRejectedEmail = (appointment, isAdminOrPartner) => appointment.status === 'REJECTED' && isAdminOrPartner
export const canViewDisputePage = (appointment) => appointment.job_id && appointment.status == 'DONE'

const showAppointmentDetails = (appointment, isAdminOrPartner) => {
  if (isAdminOrPartner) window.open('/admin-appointment/' + appointment.id, '_blank')
  else window.open('/appointments/' + appointment.id, '_blank')
}

const showConfirmationPage = (appointment) => {
  window.open('/confirm-appointment/' + appointment.id + '?isChangeDateAllowed=true', '_blank')
}

export const options = (appointment, groupId, isAdminOrPartnerParam) => {
  const isAdminOrPartner =
    typeof isAdminOrPartnerParam === 'boolean'
      ? isAdminOrPartnerParam
      : isAdminOrPartnerFromStorage()

  const isRealEstate = isRealEstateFromStorage()

  return [
  {
    show: true,
    fetchAppointment: false,
    modal: null,
    icon: 'mdi-eye-outline',
    title: Vue.i18n.translate('appointment.adminActions.showDetails'),
    action: () => showAppointmentDetails(appointment, isAdminOrPartner)
  },
  {
    show: canRemoveGroup(groupId),
    modal: 'REMOVE_APPOINTMENT_FROM_GROUP_MODAL',
    icon: 'mdi-trash-can-outline',
    title: Vue.i18n.translate('appointment.adminActions.removeFromGroup'),
  },
  {
    show: true,
    fetchAppointment: true,
    modal: 'RESCHEDULE_APPOINTMENT_MODAL',
    icon: 'mdi-calendar-refresh-outline',
    title: Vue.i18n.translate('appointment.adminActions.reschedule'),
  },
  {
    show: canCancel(appointment, groupId),
    fetchAppointment: true,
    modal: 'CANCEL_APPOINTMENT_MODAL',
    icon: 'mdi-calendar-remove-outline',
    title: Vue.i18n.translate('board.actions.cancel'),
  },
  {
    show: canAddOrEditCustomFields(isAdminOrPartner),
    fetchAppointment: true,
    modal: 'ADDITIONAL_INFO_APPOINTMENT_MODAL',
    icon: 'mdi-information-box-outline',
    title: Vue.i18n.translate('appointment.adminActions.additionalInfo'),
  },
  {
    show: canSendConfirmationEmail(appointment, isAdminOrPartner),
    fetchAppointment: true,
    modal: 'BULK_SEND_CONFIRMATION_EMAIL_MODAL',
    icon: 'mdi-email-check-outline',
    title: Vue.i18n.translate('mapDrawing.sendConfirmationEmail'),
  },
  {
    show: canSendPropertyManagerRejectedEmail(appointment, isAdminOrPartner),
    fetchAppointment: true,
    modal: 'BULK_SEND_REJECTED_EMAIL_MODAL',
    icon: 'mdi-email-remove-outline',
    title: Vue.i18n.translate('mapDrawing.sendRejectedEmail'),
  },
  {
    show: canConfirmAppointmentManually(isAdminOrPartner),
    fetchAppointment: true,
    modal: 'CONFIRM_APPOINTMENT_MODAL',
    icon: 'mdi-email-check-outline',
    title: Vue.i18n.translate('appointment.adminActions.confirmAppointmentManually'),
  },
  {
    show: canAddOrEditObservations(isAdminOrPartner),
    fetchAppointment: true,
    modal: 'UPDATE_OBSERVATIONS_APPOINTMENT_MODAL',
    icon: 'mdi-text-box-edit-outline',
    title: Vue.i18n.translate('appointment.adminActions.updateObservations.action'),
  },
  {
    show: canUpdateDisplacement(appointment, groupId, isAdminOrPartner, isRealEstate),
    fetchAppointment: true,
    modal: 'UPDATE_DISPLACEMENT_APPOINTMENT_MODAL',
    icon: 'mdi-cash-edit',
    title: Vue.i18n.translate('appointment.adminActions.updateDisplacement.action'),
  },
  {
    show: canAddHost(appointment, groupId, isAdminOrPartner),
    fetchAppointment: true,
    modal: 'ADD_HOST_MODAL',
    icon: 'mdi-account-plus',
    title: Vue.i18n.translate('appointment.adminActions.addHost.action'),
  },
  {
    show: canChangeHost(appointment, groupId, isAdminOrPartner),
    fetchAppointment: true,
    modal: 'CHANGE_APPOINTMENT_HOST_MODAL',
    icon: 'mdi-account-sync-outline',
    title: Vue.i18n.translate('appointment.adminActions.changeHost.action'),
  },
  {
    show: canChangeInspector(appointment, groupId, isRealEstate),
    fetchAppointment: true,
    modal: 'CHANGE_APPOINTMENT_INSPECTOR_MODAL',
    icon: 'mdi-account-sync-outline',
    title: appointment.host
      ? Vue.i18n.translate('appointment.adminActions.changeInspector.action')
      : Vue.i18n.translate('appointment.adminActions.changeInspector.setAction'),
  },
  {
    show: canEditVisitor(appointment),
    fetchAppointment: true,
    modal: 'EDIT_VISITOR_MODAL',
    icon: 'mdi-account-details-outline',
    title: isServiceAVisitType ? Vue.i18n.translate('board.actions.editVisitor') : Vue.i18n.translate('board.actions.editTenant'),
  },
  {
    show: canChangeAppointmentStatus(appointment, isAdminOrPartner, isRealEstate, groupId),
    fetchAppointment: true,
    modal: 'CHANGE_APPOINTMENT_STATUS_MODAL',
    icon: 'mdi-flag-outline',
    title: Vue.i18n.translate('appointment.adminActions.changeStatus.action'),
  },
  {
    show: canChangeAppointmentKeyLocation(appointment, isAdminOrPartner),
    fetchAppointment: true,
    modal: 'CHANGE_APPOINTMENT_KEY_LOCATION_MODAL',
    icon: 'mdi-key-outline',
    title: Vue.i18n.translate('appointment.adminActions.changeKeyLocation.action'),
  },
  {
    show: canChangeAppointmentType(appointment, isAdminOrPartner),
    fetchAppointment: true,
    modal: 'CHANGE_APPOINTMENT_TYPE_MODAL',
    icon: 'mdi-briefcase-arrow-left-right-outline',
    title: Vue.i18n.translate('appointment.adminActions.changeType.action'),
  },
  {
    show: canViewConfirmAppointmentPage(isAdminOrPartner),
    fetchAppointment: false,
    modal: null,
    icon: 'mdi-file-document-check-outline',
    title: Vue.i18n.translate('appointment.adminActions.showConfirmationPage'),
    action: () => showConfirmationPage(appointment)
  },
  {
    show: canViewDisputePage(appointment),
    fetchAppointment: true,
    modal: null,
    icon: 'mdi-file-search-outline',
    title: Vue.i18n.translate('board.actions.dispute'),
    type: 'dispute',
  },
]
}
